import { render } from "./pencil-icon.vue?vue&type=template&id=7da15c1e"
const script = {}
script.render = render

export default script